import Vue from "vue";
import {
    store
} from "./Store"
import Router from "vue-router";
const FrontPage = () => import("./pages/frontpage.vue");
const Navbar = () => import("./layout/Nav.vue");
const Home = () => import('./pages/home.vue');
const Common = () => import('./pages/common.vue');
const Sidebar = () => import('./pages/sidebar.vue');
Vue.use(Router);
const w = Vue.prototype;

const routes = [{
        path: "/",
        name: "frontpage",
        components: {
            default: FrontPage,
            header: Navbar
        },
        meta: {
            page: 1
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/home",
        name: "home",
        components: {
            default: Home,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            requiresAuth: true,
            gql: false,
            module: 'Entity'
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/clients",
        name: "clients",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            module: 'Clients',
            gql: 'clients',
            requiresAuth: true
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/business",
        name: "business",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            module: 'Business Lines',
            gql: 'business',
            requiresAuth: true
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/groups",
        name: "groups",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            module: 'Groups',
            gql: 'groups',
            requiresAuth: true
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/procedures",
        name: "procedures",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            module: 'Procedures',
            gql: 'procedures',
            requiresAuth: true
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/instructions",
        name: "instructions",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            module: 'Instructions',
            gql: 'instructions',
            requiresAuth: true
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/policies",
        name: "policies",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            module: 'Policies',
            gql: 'policies',
            requiresAuth: true
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/programs",
        name: "programs",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            module: 'Programs',
            gql: 'programs',
            requiresAuth: true
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/reporting",
        name: "reporting",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            requiresAuth: true,
            gql: false,
            module: 'Entity'
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    },
    {
        path: "/settings",
        name: "settings",
        components: {
            default: Common,
            menu: Sidebar,
            header: Navbar
        },
        meta: {
            page: 2,
            requiresAuth: true,
            gql: false,
            module: 'Entity'
        },
        props: {
            header: {
                colorOnScroll: 675
            }
        }
    }
]

const router = new Router({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {
    store.commit('change', {
        target: false
    });
    if (to.meta && to.meta.module) {
        store.commit('change', {
            module: to.meta.module
        });
    }
    if (to.meta && to.meta.gql ) {
        store.commit('change', {
            gql: to.meta.gql
        });
    } else {
        store.commit('change', {
            gql: false
        });
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
            store.commit('change', {
                slideWrapper: 'hidden'
            });
        if (!store.getters.get('user')) {
            store.commit('change', {
                target: to.name
            });
            var init = JSON.parse(store.getters.get('init'))
            init.target = to.name
            store.commit('change', {
                init: JSON.stringify(init)
            });
            w.$eventBus.$emit('authState', 'signIn')
            next({
                path: '/'
            });
        } else {
            next()
        }
    } else {
        next()
    }
})
export default router
